// generated by genversion
export var version = '4.2.9';
//# sourceMappingURL=version.js.map